import {BackendApi} from '@/services/backend_api'

export default {
  get (pageName) {
    return BackendApi.getAnonymousClient().get(`page-contents/${pageName}`)
    .then(response => { return response })
    .catch(e => { throw e })
  },
  put (pageContent) {
    return BackendApi.getClient().put(`page-contents/${pageContent.pageName}`, pageContent)
    .then(response => { return response })
    .catch(e => { throw e })
  }
}



// WEBPACK FOOTER //
// ./src/services/resource_client/cms.js